import { render, staticRenderFns } from "./VesselMmsiDeny.vue?vue&type=template&id=2168e7f8&scoped=true&"
import script from "./VesselMmsiDeny.vue?vue&type=script&lang=js&"
export * from "./VesselMmsiDeny.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2168e7f8",
  null
  
)

export default component.exports